import { Folder } from '@anm/api/modules/videoFolder';
import BreadcrumbItem from '@anm/components/Breadcrumbs/BreadcrumbItem';
import { TooltipDescription, TooltipLink } from '@anm/components/PlayerBlock/PlayerStatuses/Wrapper';
import getFromCdn from '@anm/helpers/getFromCdn';
import { getLinkTarget } from '@anm/helpers/upgradeLink';
import { FC, ReactText } from 'react';

import vtConfig from '../../../config';

import { BreadcrumbBadge, TooltipWrapper } from './Wrapper';
import { ProjectBreadcrumbItem } from './hooks';

const { urls } = vtConfig();
export type CustomizationBreadcrumbItemProps = Folder | ProjectBreadcrumbItem;

const isProjectItem = (projectItem: CustomizationBreadcrumbItemProps): projectItem is ProjectBreadcrumbItem =>
  (projectItem as ProjectBreadcrumbItem).isDraft;

const TooltipContent: FC<{ projectId: ReactText }> = ({ projectId }) => (
  <>
    <TooltipDescription>This video has been</TooltipDescription>
    <TooltipDescription>changed. To update, publish</TooltipDescription>
    <TooltipDescription isInline>it</TooltipDescription>
    <TooltipDescription isInline>
      <a href={`${urls.editor}/#p=${projectId}`} target={getLinkTarget()}>
        <TooltipLink margin="0 0 0 5px">in the Editor.</TooltipLink>
      </a>
    </TooltipDescription>
  </>
);

const CustomizationBreadcrumbItem: FC<CustomizationBreadcrumbItemProps> = props => (
  <>
    <BreadcrumbItem {...props} canShortImmediately={false} />
    {isProjectItem(props) && props.isDraft && (
      <TooltipWrapper
        variant="black"
        delayShow={750}
        delayHide={50}
        width="fit-content"
        direction="to-bottom"
        renderContent={() => <TooltipContent projectId={props.id} />}
        withArrow
      >
        <BreadcrumbBadge icon={getFromCdn('images/dashboard/draft-thin-icon.svg')} variant="orange" />
      </TooltipWrapper>
    )}
  </>
);

export default CustomizationBreadcrumbItem;
